import React from 'react'
import { Bell } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminNotifications = () => {
  return (
    <GenericTable
      tableName="notifications"
      title="Notifications"
      icon={Bell}
      iconColor="rose"
      searchFields={['notification_number', 'customer_id', 'user_email', 'notification_type', 'notification_title']}
      hiddenFields={['notification_id', 'created_at', 'updated_at']}
      primaryKey="notification_id"
      defaultFields={['notification_number', 'customer_id', 'user_email', 'notification_type', 'notification_title', 'notification_status', 'is_read', 'created_at']}
      addFields={['customer_id', 'user_email', 'notification_type', 'notification_title', 'notification_message', 'notification_status', 'is_read']}
      editFields={[
        'customer_id', 'user_email', 'notification_type', 'notification_title', 
        'notification_message', 'notification_status', 'is_read', 'priority_level',
        'scheduled_at', 'sent_at', 'read_at'
        // Excluded: notification_id, notification_number, created_at, updated_at
      ]}
    />
  )
}

export default AdminNotifications
